<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="修改密码"
                left-arrow
                @click-left="onClickLeft"
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
<!--            <template #right>-->
<!--                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>-->
<!--            </template>-->
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.2rem">
            <van-form @submit="onSubmit">
<!--                <van-field-->
<!--                        v-model="username"-->
<!--                        name="用户名"-->
<!--                        label="用户名"-->
<!--                        placeholder="用户名"-->
<!--                        :rules="[{ required: true, message: '请填写用户名' }]"-->
<!--                />-->
                <van-field
                        v-model="oldPassword"
                        type="password"
                        name="密码"
                        label="原密码"
                        placeholder="原密码"
                        :rules="[{ required: true, message: '请填写原密码' }]"
                />
                <van-field
                        v-model="newPassword"
                        type="password"
                        name="新密码"
                        label="新密码"
                        placeholder="新密码"
                        :rules="[{ required: true, message: '请填写新密码' }]"
                />
                <!-- <van-field
                    v-model="sms"
                    center
                    clearable
                    label="短信验证码"
                    placeholder="请输入短信验证码"
                    >
                    <template #button>
                        <van-button size="small" @click.prevent="btnClick()" type="primary">{{btntitle}}</van-button>
                    </template>
                    </van-field> -->
                <!--提交  -->
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">
                        提交
                    </van-button>
                </div>
            </van-form>


        </div>
        <!--内容 end-->
    </div>
</template>

<script>
    import { Notify } from 'vant';
    export default {
        name: "StaffManagement", //找回密码
        data(){
            return{
                // username:'',
                oldPassword:"",
                newPassword:""
                //  sms: '',
                //  btntitle: "获取验证码",
                //  cansend: false,
                //  timer: null
            }
        },
        methods: {
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/MyAgent');
            },
            // 右侧icon跳转至商户首页
            // onClickRight() {
            //     // 返回商户首页
            //     this.$router.push('/MerchantHomepage');
            // },
            // 获取验证码
            //      btnClick(){
            //     if (this.cansend==false) {
            //         console.log("点击了");
            //         // 发送请求
            //         // this.sendLoginSms()
            //         // 倒计时
            //         this.cansend = false;
            //         let countdown = 60;
            //         this.btntitle = countdown;
            //         this.timer = setInterval(()=>{
            //         countdown --;
            //     if (countdown <= 0) {
            //         clearInterval(this.timer);
            //         this.timer = null;
            //         this.btntitle = "重新发送";
            //         this.cansend = true;
            //     }else{
            //         this.btntitle = countdown;
            //        }
            //      },1000);
            //     }
            // },
            // 提交
            onSubmit(values) {
                console.log("111111111111111");
                console.log('submit', values);
                this.choos()

            },
            choos(){
                this.$http.post('/wechat/api.agent.index/changePwd', {
                        oldPassword:this.oldPassword,
                        newPassword:this.newPassword
                }).then(response => {
                    if (response.data.code==200){
                        console.log(response.data);
                        Notify({ type: 'success', message: response.data.msg });
                        sessionStorage.clear();
                        this.$router.push("/AgentImpower");
                    }else{
                        Notify({ type: 'danger', message: response.data.msg });
                    }


                })
            }
        },

    }
</script>

<style scoped>

</style>
